
/**
 * WebSocket API Configuration
 * 
 * This service provides a centralized way to create WebSocket connections,
 * mirroring the pattern used in baseapi.ts for REST endpoints.
 */

const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const wsBaseURL = `${wsProtocol}//${window.location.host}/api/ws/`;

/**
 * Creates a configured WebSocket instance.
 * 
 * @param endpoint The websocket endpoint path (e.g., 'ws/site_map_alerts/')
 * @returns A new WebSocket instance with authentication token automatically attached.
 * 
 * Usage:
 * const socket = createSocket('ws/site_map_alerts/');
 * socket.onmessage = (event) => { ... };
 */
const createSocket = (endpoint: string) => {
  const token = localStorage.getItem('access_token');
  
  // Construct the full URL relative to our API base
  // URL constructor handles path joining correctly if baseURL ends with /
  const url = new URL(endpoint, wsBaseURL);

  // Since browser WebSocket API doesn't support custom headers,
  // we attach the access token as a query parameter.
  if (token) {
    url.searchParams.append('token', token);
  }

  return new WebSocket(url.toString());
};

export default createSocket;
